import validator from 'validator';

const validatesendReport = (data) => {
  let errors = {}

  const {stype} = data;
  if(validator.isEmpty(stype)) {
    errors.stype =  "Please select one category";
  }
  return {
    isInvalid: Object.keys(errors).length > 0,
    error: errors
  }
}

export default validatesendReport;